// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-90c0e51c]::-webkit-scrollbar {\n    width: 3px;\n}\n\n/* Track */\n[data-v-90c0e51c]::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n/* Handle */\n[data-v-90c0e51c]::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n/* Handle on hover */\n[data-v-90c0e51c]::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
